import { cardStatementService } from "../services/cardStatement.service";
import { show as showAlert } from "../../Notifications/actions/alert.actions";
import { message } from "../../../constants/app.constants";
import {
  cardStatementConstants,
  nameSpace
} from "../constants/cardStatement.constants";
import { createRequestBody } from "../factories/cardStatements.factory";
import { appUtils } from "../../../utils/app.utils";
import { store } from "../../../store";


export const searchCardStatement = requestParams => {
  return async dispatch => {
    const requestObject = createRequestBody(requestParams);

    const issuerData = store.getState().cardProgramCount.request;
    if(issuerData && issuerData.domainCode !== "ISW") {
      requestObject.issuerNumber = issuerData.issuerNr
    }

    dispatch(request(requestParams));
    try {
      const response = await cardStatementService.getCardStatement(
        requestObject.cardPan,
        requestObject.requestParams
      );
      response && dispatch(success(response));
    } catch (error) {
      dispatch(failure(error));
      dispatch(
        showAlert(
          "danger",
          "Failed to get card statement",
          error ? error.message : message.GENERIC_ERROR
        )
      );
    }
  };

  function request(request) {
    return {
      type: cardStatementConstants[`GET_${nameSpace}_REQUEST`],
      request
    };
  }
  function success(response) {
    return {
      type: cardStatementConstants[`GET_${nameSpace}_SUCCESS`],
      response
    };
  }
  function failure(error) {
    return { type: cardStatementConstants[`GET_${nameSpace}_FAILURE`], error };
  }
};

export const downloadCardStatement = requestParams => {
  return async dispatch => {
    const requestObject = createRequestBody(requestParams);
    dispatch(request(requestParams));
    try {
      const response = await cardStatementService.getCardStatement(
        requestObject.cardPan,
        requestObject.requestParams
      );

      if (response) {
        dispatch(success(response));
        const cardStatementDownloadLink =
          response.data && response.data.length
            ? response.data[0].downloadLink
            : null;
       
        appUtils.downloadFile(cardStatementDownloadLink);
      }
    } catch (error) {
      dispatch(failure(error));
      dispatch(
        showAlert(
          "danger",
          "Failed to download card statement",
          error ? error.message : message.GENERIC_ERROR
        )
      );
    }
  };

  function request(request) {
    return {
      type: `DOWNLOAD_${nameSpace}_REQUEST`,
      request
    };
  }
  function success(response) {
    return {
      type: `DOWNLOAD_${nameSpace}_SUCCESS`,
      response
    };
  }
  function failure(error) {
    return { type: `DOWNLOAD_${nameSpace}_FAILURE`, error };
  }
};

export const resetStatements = () => {
  return { type: cardStatementConstants[`GET_${nameSpace}_RESET`] };
};

export const resetStatementDownload = () => {
  return { type: `DOWNLOAD_${nameSpace}_RESET` };
};